"use client"

import styled from "@emotion/styled"
import { Container, NewText } from "ui"

import { GetStockDataResponse } from "lib/api"
import colors from "theme/colors"
import { extractProperty } from "utils"
import StockChart from "./StockChart/StockChart"
import { StatsType } from "lib/utils"

const StyledMargins = styled.div`
  padding-top: 28px;
  padding-bottom: 40px;
  display: flex;
  flex-direction: column;
  gap: 40px;
  ${(props) => props.theme.breakpoints.up("md")} {
    padding-top: 31px;
    padding-bottom: 53px;
  }
  ${(props) => props.theme.breakpoints.up("lg")} {
    padding-top: 46px;
    padding-bottom: 80px;
  }
  p {
    margin: 0;
  }
`
type Props = {
  data: any
  stockData: GetStockDataResponse
  financialStats: StatsType
  locale: string
}

function Information({ data, stockData, locale, financialStats }: Props) {
  const text = extractProperty(data, "innerText")
  return (
    <Container>
      <StyledMargins>
        <NewText
          component="div"
          desktopFontSize={36}
          desktopLineHeight="140%"
          mobileFontSize={20}
          color={colors.black}
          dangerouslySetInnerHTML={{ __html: text }}
        />
      </StyledMargins>
      <StockChart
        stockData={stockData}
        locale={locale}
        financialStats={financialStats}
      />
    </Container>
  )
}

export default Information
